import {
    Attachment,
    ComposeMessageEditorErrorType,
    ComposeStateType,
    ComposeTopLevelErrorType,
} from "../../reducer.types";
import { NHSAdviceLink } from "../../types";
import { validateAttachmentLoading } from "./validateAttachmentLoading";
import { validateContactDetails } from "./validateContactDetails";
import { validatePatientMessageLength } from "./validatePatientMessageLength";
import { validatePlaceholderInMessage } from "./validatePlaceholderInMessage";
import { validateQuestionnaireLoading } from "./validateQuestionnaireLoading";
import { validateScheduledTime } from "./validateScheduledTime";

export type ValidateMessageProps = {
    messageBody: string;
    messageSignature: string;
    attachments: Attachment[];
    contactMethod: ComposeStateType["contactDetails"]["method"];
    workspaceName: string;
    originalGreeting: string;
    originalSignature: string;
    template: ComposeStateType["template"];
    nhsAdviceLink: NHSAdviceLink | null;
    withSelfBookLink: boolean;
    withPatientResponseEnabled: boolean;
    sendAtDateTime: string | null;
};

export const validateCompose = (arg: {
    contactMethod: ComposeStateType["contactDetails"]["method"];
}): ComposeTopLevelErrorType => {
    return validateContactDetails(arg);
};

export const validateMessage = (
    arg: ValidateMessageProps,
): ComposeMessageEditorErrorType => {
    return {
        ...validateAttachmentLoading(arg),
        ...validatePatientMessageLength(arg),
        ...validateQuestionnaireLoading(arg),
        ...validatePlaceholderInMessage(arg),
        ...validateAttachmentLoading(arg),
        ...validateScheduledTime(arg),
    };
};
